<navbar></navbar>
<router-outlet></router-outlet>


